const objectItems = {
  label1: 'Calendário',
  label2: 'Ações Geradas',
  label3: 'Locais',
  label4: 'Mapa',
  label5: 'Dashboard',
  label6: 'Equipamentos',
  label7: 'Serviços',
  label8: 'Empresas Terceiras',
  label9: 'Usuários',
  label10: 'Departamentos',
  label11: 'Tipos de Equipamentos',
  label12: 'Grupos',
  label13: 'Periodicidades',
  label14: 'Tipos de Serviços',
  label15: 'Minha Conta',
  label16: 'Arquivos de apoio',
  label17: 'Backups (App)',
  label19: 'Manutenções',
  label18: 'Relatórios',
  label20: 'Serviços Atrasados',
  label21: 'Serviços Agendados',
  label22: 'Calendário de Serviços Agendados',
  label23: 'Configurações',
  label24: 'Relatórios Exportados',
  serviceDrafts: 'Rascunhos de Serviço',
}

export default objectItems;
